export const ensureHttpsWebCrawlUrl = (url: string): string => {
    const trimmed = url.trim();
    if (!trimmed) {
        return '';
    }

    if (/^https:\/\//i.test(trimmed)) {
        return trimmed;
    }

    if (/^http:\/\//i.test(trimmed)) {
        return trimmed.replace(/^http:\/\//i, 'https://');
    }

    return `https://${trimmed}`;
};
